module.exports = __webpack_public_path__ + "img/2-4.377fd7aa.png";